"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _search = _interopRequireDefault(require("@/components/college/search.vue"));
var _courseItem = _interopRequireDefault(require("@/components/college/courseItem.vue"));
var _index = require("@/api/college/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseItem: _courseItem.default,
    Search: _search.default
  },
  props: {},
  data: function data() {
    return {
      query: {
        pageNum: 1,
        pageSize: 18,
        courseName: '',
        majorName: ''
      },
      total: 0,
      fictitiousCourse: []
    };
  },
  created: function created() {
    this.getFictitiousCourse();
  },
  methods: {
    toSsearch: function toSsearch(e) {
      // console.log('dianji',e)
      this.query.courseName = e.courseName;
      this.query.majorName = e.majorName;
      this.getFictitiousCourse();
    },
    getFictitiousCourse: function getFictitiousCourse() {
      var _this = this;
      (0, _index.peCourseList)({
        courseType: "14",
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize,
        provinceId: this.$store.getters.provinceId,
        schoolId: this.$store.getters.wShoolInfo.id,
        showStatus: "1",
        courseName: this.query.courseName,
        majorName: this.query.majorName
      }).then(function (res) {
        if (res.code === 2000) {
          for (var i in res.data.list) {
            if (res.data.list[i].courseImage) {
              res.data.list[i].courseImage = res.data.list[i].courseImage.substring(0, res.data.list[i].courseImage.indexOf('?'));
            }
          }
          _this.fictitiousCourse = res.data.list;
          _this.total = res.data.total;
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getFictitiousCourse();
    }
  }
};